import i18n from 'services/i18n'

export function translateWithDefault (key, defaultTranslation) {
    return i18n.te(key) ? i18n.t(key) : defaultTranslation
}
